/* eslint-disable */
/**
 * 返回gid 视频请求唯一id
 * @return {string}
 */
function createGid() {
    const key = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_-';
    // 28
    let ramStr = parseInt(Math.random() * 268435455).toString(2);
    // 44
    let mtimeStr = new Date().getTime().toString(2);

    while (ramStr.length < 28) {
        ramStr = `0${ramStr}`;
    }

    while (mtimeStr.length < 44) {
        mtimeStr = `0${mtimeStr}`;
    }

    const binaryStr = ramStr + mtimeStr;

    let outStr = '';

    for (let i = 0; i < 12; i++) {
        outStr += key.charAt(parseInt(binaryStr.substr(i * 6, 6), 2));
    }

    return outStr;
}

export default createGid;



// WEBPACK FOOTER //
// /Users/zhujian/Desktop/code/live_system/live/modules/f.component.util/app/lib/auth/utils/gid.js